import React from "react";

import PageHeading from "2g-page-heading";

import ProvozniInformaceWidget from "b2b/components/provozni-informace-widget/ProvozniInformaceWidget";

export function ProvozniInformaceWidgetExample() {
  return (
    <>
      <PageHeading>ProvozniInformaceWidget</PageHeading>
      <div data-testid="ProvozniInformaceWidget">
        <ProvozniInformaceWidget />
      </div>
    </>
  );
}

ProvozniInformaceWidgetExample.propTypes = {};

export default React.memo(ProvozniInformaceWidgetExample);
